var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.exportTransactions}},[_vm._v("Export")])])}
var staticRenderFns = []

export { render, staticRenderFns }